import { Collapse } from "antd";
import Address from "./main";
import { useSelector } from "react-redux";
const { Panel } = Collapse;
const Stores = ({ address }) => {
  const user = useSelector((state) => state.user);
  const callback = (key) => {
    console.log(key);
  };
  return (
    <div className="sm:p-10">
      {address?.length === 0 ? (
        <div className="p-6 bg-[#F4F5FE] rounded-md sm:p-8  mb-8 ">
          <h3 className="text-[1rem] font-semibold leading-none text-gray-600 text-center">
            No Record Found
          </h3>
        </div>
      ) : (
        <Collapse defaultActiveKey={["1"]} onChange={callback} accordion={true}>
          {address?.map((address, index) => {
            return (
              <Panel
                header={`Company Address ${index + 1}`}
                key={index + 1}
                className="sm:p-3 text-md text-gray-800 font-medium"
              >
                <Address title={`Company Address ${index + 1}`} headquarter={address} />
              </Panel>
            );
          })}
        </Collapse>
      )}
    </div>
  );
};

export default Stores;
